module.exports = __webpack_public_path__ + "img/kr-product-intl-card4-img3.f2bdb47.png";